import Portal from "@client/controls/Portal/component";
import Popup, { type PopupProps } from "@client/layout/Popup/container";
import * as React from "react";

import "./style.less";

export type MapProps = PopupProps & {
  canClose: boolean;
  keepOpenOnOverlayClick: boolean;
  overlayStyle: React.CSSProperties;
  children?: any;
  topMenu?: any;
};

export interface ActionProps {
  close: () => void;
}

export default ({ overlayStyle, keepOpenOnOverlayClick, ...props }: MapProps & ActionProps) => (
  <>
    {!!props.topMenu && <Portal>{props.topMenu}</Portal>}

    <Portal parentSelector=".wsc_viewport">
      <div className="wsc_popup_container no-close-click-outside">
        <div
          className="wsc_popup_overlay"
          style={overlayStyle}
          onClick={keepOpenOnOverlayClick || !props.canClose ? undefined : props.close}
        >
          <Popup {...props} />
        </div>
      </div>
    </Portal>
  </>
);
